import { render, staticRenderFns } from "./travelerViewData.vue?vue&type=template&id=608f67e8&scoped=true&"
import script from "./travelerViewData.vue?vue&type=script&lang=js&"
export * from "./travelerViewData.vue?vue&type=script&lang=js&"
import style0 from "./travelerViewData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./travelerViewData.vue?vue&type=style&index=1&id=608f67e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608f67e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('608f67e8')) {
      api.createRecord('608f67e8', component.options)
    } else {
      api.reload('608f67e8', component.options)
    }
    module.hot.accept("./travelerViewData.vue?vue&type=template&id=608f67e8&scoped=true&", function () {
      api.rerender('608f67e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/travelerViewData.vue"
export default component.exports